import { render, staticRenderFns } from "./LinkQR.vue?vue&type=template&id=44715a08&scoped=true"
import script from "./LinkQR.vue?vue&type=script&lang=js"
export * from "./LinkQR.vue?vue&type=script&lang=js"
import style0 from "./LinkQR.vue?vue&type=style&index=0&id=44715a08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44715a08",
  null
  
)

export default component.exports